import Vue from 'vue';
import { Store, StoreOptions } from 'vuex';
import Vuetify from 'vuetify';
import VueI18n from 'vue-i18n';
import VueRouter from 'vue-router';

import routesConfig, { CheeersRouteConfig } from '@/config/routes';
import cheeersConfig, { CheeersConfig } from '@/config';
import storeConfig from '@/store';
import registerNotification from '@/helper/notification';

import BootstrapVeeValidate from './heplers/vee-validate';
import BootstrapVuetify from './heplers/vuetify';
import BootstrapVueI18N from './heplers/vue-i18n';
import BootstrapAuthentication from './heplers/authentication';
import BootstrapRouter from './heplers/router';
import BootstrapAxios from './heplers/axios';
import BootstrapConfig from './heplers/config';
import BootstrapVueX from './heplers/vuex';
import BootstrapCheeersHelper from './heplers/cheeers';
import BootstrapServiceWorker from './heplers/service-worker';
import BootstrapAPIBuilder from './heplers/api-builder';

// plugins
import '../mixin/global';

// CSS/SCSS
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@fortawesome/fontawesome-free/css/all.css';
import 'animate.css/animate.min.css';
import '../assets/sass/main.scss';
import '../components/global';

import 'vue-tour/dist/vue-tour.css';

interface Config<T = any> {
  vuetify: Vuetify;
  i18n: VueI18n;
  router: VueRouter;
  store: Store<T>;
}

export async function Bootstrap(
  routes: CheeersRouteConfig[],
  storeOptions: StoreOptions<any>,
  configOptions: CheeersConfig,
): Promise<Config> {
  BootstrapServiceWorker();
  const i18n = BootstrapVueI18N();
  const vuetify = BootstrapVuetify(i18n);
  const config = BootstrapConfig(configOptions);
  const store = BootstrapVueX(storeOptions);
  BootstrapVeeValidate(i18n);

  BootstrapCheeersHelper(store);
  const authentication = BootstrapAuthentication(
    config.authentication.loginApi,
    config.authentication.logoutApi,
    config.authentication.checkAuthApi,
    Vue.prototype.$http,
    store,
  );
  const router = BootstrapRouter(routes, config, Vue.prototype.$auth);
  const axios = BootstrapAxios(config.authentication, router);

  BootstrapAPIBuilder(axios);

  authentication.setAxios(axios);

  registerNotification(axios);

  Vue.config.productionTip = false;

  try {
    await store.dispatch('staff/fetchCurrentStaff');
    await store.dispatch('staff/getNotifyStaffByTheFirstAccessPage');
    await store.dispatch('staff/historyLogin');
  } catch (e) {
    console.error(e);
  }

  return {
    vuetify,
    i18n,
    router,
    store,
  };
}

export default async () => Bootstrap(routesConfig, storeConfig, cheeersConfig);
